import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, trackView } from "@/lib/analytics";

/** Mount once inside the router: inits the analytics batcher and fires a
 *  `view` event on every route change. */
export function useAnalytics(): void {
  const { pathname } = useLocation();
  const initedRef = useRef(false);

  useEffect(() => {
    if (initedRef.current) return;
    initedRef.current = true;
    void initAnalytics();
  }, []);

  useEffect(() => {
    trackView(pathname);
  }, [pathname]);
}
